import React, { Component } from 'react';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledTooltip } from 'reactstrap';
import { faList } from '@fortawesome/free-solid-svg-icons';
export default class LinksActionMenu extends Component {
  constructor(props) {
    super(props);
    this.toggle = () => this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
    this.key = num => "k".concat(new Date().getTime()).concat(num);
    this.items = () => {
      const items = [];
      this.props.menuItems.map((item, idx) => {
        items.push( /*#__PURE__*/React.createElement("div", {
          id: "action_menu_tip_".concat(idx),
          key: "action_menu_tip_".concat(idx)
        }, /*#__PURE__*/React.createElement(DropdownItem, {
          key: this.key(idx),
          onClick: () => item.action(event),
          disabled: item.disabled
        }, item.label)));
      });
      return items;
    };
    this.tips = () => {
      const tips = [];
      const length = this.props.menuItems.length;
      this.props.menuItems.map((item, idx) => {
        if (item.tooltip !== null) {
          tips.push( /*#__PURE__*/React.createElement(UncontrolledTooltip, {
            placement: this.state.direction,
            target: "action_menu_tip_".concat(idx),
            key: this.key(idx + length)
          }, /*#__PURE__*/React.createElement("div", {
            className: "text-left"
          }, item.tooltip)));
        }
      });
      return tips;
    };
    this.dropdown = () => /*#__PURE__*/React.createElement(ButtonDropdown, {
      direction: this.state.direction,
      isOpen: this.state.isOpen,
      toggle: this.toggle
    }, /*#__PURE__*/React.createElement(DropdownToggle, {
      caret: true,
      className: this.state.className,
      color: this.state.color,
      outline: true
    }, this.props.dropdownLabel), /*#__PURE__*/React.createElement(DropdownMenu, null, this.items()));
    this.state = {
      isOpen: false
    };
    this.state.direction = this.props.direction || 'left';
    this.state.color = this.props.color || 'info';
    this.state.className = this.props.className || '';
  }
  render() {
    return /*#__PURE__*/React.createElement("span", null, this.dropdown(), this.tips());
  }
}